import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import enTranslation from './locales/en/translation.json'
import mnTranslation from './locales/mn/translation.json'

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: true,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['cookie', 'localStorage'],
        caches: ['cookie'],
        cookieMinutes: 10080,
        cookieDomain: typeof window !== 'undefined' ? window.location.hostname : 'localhost',
      },
      resources: {
        en: { translation: enTranslation },
        mn: { translation: mnTranslation },
      },
      fallbackLng: 'mn',
    })
}

export default i18n
